const PUBLIC_PAGES = ['/login'];

export const authGuard = (router) => router.beforeEach((to, from, next) => {
  const authRequired = !PUBLIC_PAGES.includes(to.path);
  const loggedIn = sessionStorage.getItem('user');
  if (authRequired && !loggedIn) {
    return next('/login');
  }
  next();
})